import { Component, Input, Output, EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { groupBy, GroupResult } from '@progress/kendo-data-query';
import { IApiUser } from 'src/app/shared/modules/graphql/types/types';

interface ICalendarUser extends IApiUser {
  itemFullName?: string;
  stateName?: string;
}

@Component({
  selector: 'app-calendar-user-filter',
  templateUrl: './calendar-user-filter.component.html',
  styleUrls: ['./calendar-user-filter.component.scss']
})

export class CalendarUserFilterComponent implements OnInit, OnChanges {

  @Input() selectedId: any[] = [];
  public users: ICalendarUser[] = [];
  @Output() selectionChanged = new EventEmitter<any[]>();
  @Output() enteredPressed = new EventEmitter<void>();

  public groupedUsers: GroupResult[] = [];
  public loading: boolean = false;
  public searchString: string = '';
  private selectedIdSet = new Set<string>();

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.users = this.route.snapshot.data['users'] || [];
    this.groupUsers();
    this.updateSelectedIdSet();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedId) {
      this.selectedId = changes.selectedId.currentValue || [];
      this.updateSelectedIdSet();
    }
  }

  private groupUsers() {
    let dataToGroup = this.users;
    if (this.searchString && this.searchString.trim().length > 0) {
      const search = this.searchString.toLowerCase();
      dataToGroup = this.users.filter(u =>
        u.itemFullName?.toLowerCase().includes(search) ||
        u.stateName?.toLowerCase().includes(search)
      );
    }
    this.groupedUsers = groupBy(dataToGroup, [{ field: 'stateName' }]) as GroupResult[];
  }

  public onSearchChange(search: string) {
    this.searchString = search || '';
    this.groupUsers();
  }

  public selectUser(selected: any) {
    this.selectedId = selected || [];
    this.updateSelectedIdSet();
    this.selectionChanged.emit(selected);
  }

  public isSelected(item: any): boolean {
    return this.selectedIdSet.has(`${item?.id}`);
  }

  public isGroupSelected(groupName: string): boolean {
    const group = this.groupedUsers.find(g => g.value === groupName);
    if (!group || !group.items || !group.items.length) {
      return false;
    }
    return group.items.every(item => this.isSelected(item));
  }

  public isGroupIndeterminate(groupName: string): boolean {
    const group = this.groupedUsers.find(g => g.value === groupName);
    if (!group || !group.items || !group.items.length) {
      return false;
    }
    const selectedCount = group.items.filter(item => this.isSelected(item)).length;
    return selectedCount > 0 && selectedCount < group.items.length;
  }

  public toggleGroup(groupName: string, event: any) {
    const checked = event.target.checked;
    const group = this.groupedUsers.find(g => g.value === groupName);
    if (!group) {
      return;
    }

    const groupIds = (group.items as ICalendarUser[])?.map(i => i.id);
    let newSelected = [...this.selectedId];

    if (checked) {
      // Add missing ones from this group
      groupIds.forEach(id => {
        if (!newSelected.some(existingId => `${existingId}` === `${id}`)) {
          newSelected.push(id);
        }
      });
    } else {
      // Remove all from this group
      newSelected = newSelected.filter(existingId =>
        !groupIds.some(groupId => `${groupId}` === `${existingId}`)
      );
    }

    this.selectUser(newSelected);
  }

  public onEnterPress() {
    // this.enteredPressed.emit();
  }

  private updateSelectedIdSet(): void {
    this.selectedIdSet = new Set((this.selectedId || []).map((id: any) => `${id}`));
  }

}
